import { createContext, useContext, useEffect, useState } from 'react';
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    onAuthStateChanged,
    updateProfile
} from 'firebase/auth';
import { auth } from '../firebase';
import { getDatabase, ref, set, get, onValue, remove, update, push, query, orderByChild, equalTo, serverTimestamp } from "firebase/database";

const UserContext = createContext();

export const AuthContextProvider = ({ children }) => {
    const [user, setUser] = useState({});

    const createUser = async (username, email, password, agentID) => {
        try {
            const result = await createUserWithEmailAndPassword(auth, email, password);
            await updateProfile(result.user, { displayName: username });
            await setUserDB(username, email, password, agentID);
            return result;
        } catch (error) {
            throw error;
        }
    };

    const signIn = (email, password) => {
        return signInWithEmailAndPassword(auth, email, password)
    }

    const deletePasukan = (username, utele) => {
        const db = getDatabase();
        const q = query(ref(db, 'pasukan/' + username), orderByChild('usernameTelegram'), equalTo(utele));
        return new Promise(async (resolve, reject) => {
            onValue(q, (snapshot) => {
                if (snapshot.exists()) {
                    const hasil = snapshot.val();
                    if (hasil) { // added null/undefined check
                        const pasukanIds = Object.keys(hasil);
                        const test = 'pasukan/' + username + '/' + pasukanIds;
                        const target = ref(db, test);
                        resolve(true);
                        remove(target)
                    } else {
                        reject('unauthorized')
                    }
                } else {
                    reject('unknown')
                }
            }, (error) => {
                reject(error.message);
            });
        });
    };

    const garapAirdrop = (username, nameProject, pasukan) => {
        const db = getDatabase();
        const dbRef = ref(db, `listAirdrop/${username}`);
        const date = new Date();
        const formattedDate = `${date.getDate().toString().padStart(2, "0")
            }/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear().toString().slice(-2)} ${date.getHours().toString().padStart(
                2,
                "0"
            )}:${date.getMinutes().toString().padStart(2, "0")}`;
        return new Promise(async (resolve, reject) => {
            const cek1 = await cekExists(username, 'listAirdrop', 'nameProject', nameProject);
            const cek2 = await cekExists(username, 'pasukan', 'usernameTelegram', pasukan);
            if (cek1 === true && cek2 === true) {
                onValue(dbRef, (snapshot) => {
                    let found = false;
                    snapshot.forEach((childSnapshot) => {
                        const id = childSnapshot.key;
                        const value = childSnapshot.val();
                        if (value.nameProject === nameProject) {
                            found = true;
                            set(ref(db, `listAirdrop/${username}/${id}/penggarap/${pasukan}`), {
                                done: formattedDate
                            }).then(() => {
                                resolve(true);
                            }).catch((error) => {
                                reject(error);
                            });
                        }
                    });
                    if (!found) {
                        reject('not found');
                    }
                }, (error) => {
                    reject(error);
                });
            } else {
                reject("not allowed")
            }
        })
    }


    const detailPasukan = (username, utele) => {
        const db = getDatabase();
        const q = query(ref(db, 'pasukan/' + username), orderByChild('usernameTelegram'), equalTo(utele));
        return new Promise((resolve, reject) => {
            onValue(q, (snapshot) => {
                const hasil = snapshot.val();
                if (hasil) {
                    const pasukanIds = Object.keys(hasil);
                    const data = pasukanIds.map((id) => ({
                        nohpTelegram: hasil[id].nohpTelegram,
                        usernameTelegram: hasil[id].usernameTelegram,
                        twitter: hasil[id].twitter,
                        email: hasil[id].email,
                        facebook: hasil[id].facebook,
                        youtube: hasil[id].youtube,
                        medium: hasil[id].medium,
                        reddit: hasil[id].reddit,
                        discord: hasil[id].discord,
                    }));
                    resolve(data);
                } else {
                    resolve([]);
                }
            }, (error) => {
                reject(error);
            });
        });
    }

    const addWallet = (
        uname,
        address, chain,
        label
    ) => {
        const db = getDatabase();
        const Data = {
            walletAddress: address,
            chain: chain,
            label: label,
            added: serverTimestamp()
        }
        return new Promise(async (resolve, reject) => {
            const walleetList = ref(db, 'listWallet/' + uname);
            const newChildRef = push(walleetList); // Use auto-generated push key
            set(newChildRef, Data)
                .then(() => {
                    resolve(true);
                })
                .catch((error) => {
                    reject(error.message);
                });
        });
    }

    const savePayment = async (
        uname,
        from, to, txHash,
        value, chain
    ) => {
        const db = getDatabase();
        const date = new Date();
        const qExpiry = ref(db, 'users/' + uname + '/expiry');
        const oldExpiry = await get(qExpiry);
        const expired = oldExpiry.val();
        let newExpiry = '';
        if (expired === '') {
            const currentDate = new Date(date);
            const futureDate = new Date(currentDate);
            futureDate.setDate(futureDate.getDate() + 30);
            newExpiry = `${futureDate.getDate()}/${futureDate.getMonth() + 1
                }/${futureDate.getFullYear()}`;
        } else {
            const dateString = expired;
            const dateParts = dateString.split("/");
            const futureDate = new Date(
                `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
            );
            futureDate.setDate(futureDate.getDate() + 30);
            newExpiry = `${futureDate.getDate()}/${futureDate.getMonth() + 1
                }/${futureDate.getFullYear()}`;

        }
        const formattedDate = `${date.getDate().toString().padStart(2, "0")
            }/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear().toString().slice(-2)} ${date.getHours().toString().padStart(
                2,
                "0"
            )}:${date.getMinutes().toString().padStart(2, "0")}`;
        const Data = {
            from: from,
            to: to,
            txHash: txHash,
            value: value,
            chain: chain,
            newExpiry: newExpiry,
            date: formattedDate,
            savedDate: serverTimestamp()
        }
        const txList = ref(db, 'tx/' + uname);
        const newChildRef = push(txList); // Use auto-generated push key

        const path = 'users/' + uname;
        const updateData = {
            expiry: newExpiry,
            tier: 'premium'
        };
        return new Promise(async (resolve, reject) => {
            const cek = await cekExists(uname, 'tx', 'txHash', txHash);
            if (cek === false) {
                set(newChildRef, Data)
                    .then(async () => {
                        update(ref(db, path), updateData);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error.message);
                    });
            } else {
                reject('Gagal! double transaction ' + txHash);
            }
        });
    }




    const addAirdrop = (
        uname,
        nameProject, chain,
        link, note
    ) => {
        const db = getDatabase();
        const Data = {
            nameProject: nameProject,
            chain: chain,
            link: link,
            note: note,
            added: { '.sv': 'timestamp' }
        }
        return new Promise(async (resolve, reject) => {
            const cek = await cekExists(uname, 'listAirdrop', 'nameProject', nameProject);
            if (cek === false) {
                const airdropList = ref(db, 'listAirdrop/' + uname);
                const newChildRef = push(airdropList); // Use auto-generated push key
                set(newChildRef, Data)
                    .then(() => {
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error.message);
                    });
            } else {
                reject(nameProject + ' sudah ada');
            }
        });
    }

    const addPasukan = (
        uname,
        nohpTelegram, usernameTelegram,
        twitter, email, facebook,
        youtube, medium, reddit, discord
    ) => {
        const db = getDatabase();
        const Data = {
            nohpTelegram: nohpTelegram,
            usernameTelegram: usernameTelegram,
            twitter: twitter,
            email: email,
            facebook: facebook,
            youtube: youtube,
            medium: medium,
            reddit: reddit,
            discord: discord,
            added: { '.sv': 'timestamp' }
        }
        return new Promise(async (resolve, reject) => {
            const cek = await cekExists(uname, 'pasukan', 'usernameTelegram', usernameTelegram);
            if (cek === false) {
                const pasukan = ref(db, 'pasukan/' + uname);
                const newChildRef = push(pasukan); // Use auto-generated push key
                set(newChildRef, Data)
                    .then(() => {
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error.message);
                    });
            } else {
                reject(usernameTelegram + ' sudah ada');
            }
        });
    }

    const updatePasukan = (
        selectedTelegram, uname,
        nohpTelegram, usernameTelegram, twitter,
        email, facebook, youtube,
        medium, reddit, discord
    ) => {
        const db = getDatabase();
        const q = query(ref(db, 'pasukan/' + uname), orderByChild('usernameTelegram'), equalTo(selectedTelegram));
        return new Promise(async (resolve, reject) => {
            const cek = await cekExists(uname, 'pasukan', 'usernameTelegram', selectedTelegram);
            if (cek === true) {
                onValue(q, (snapshot) => {
                    const hasil = snapshot.val();
                    if (hasil) {
                        const pasukanIds = Object.keys(hasil);
                        const existingData = hasil[pasukanIds];
                        const path = 'pasukan/' + uname + '/' + pasukanIds;
                        const updates = {};
                        const updateData = {
                            nohpTelegram: nohpTelegram,
                            usernameTelegram: usernameTelegram,
                            twitter: twitter,
                            email: email,
                            facebook: facebook,
                            youtube: youtube,
                            medium: medium,
                            reddit: reddit,
                            discord: discord,
                            added: existingData.added
                        };
                        updates[path] = null;
                        updates[`pasukan/${uname}/${pasukanIds}`] = updateData;
                        update(ref(db), updates)
                            .then(() => {
                                resolve(true);
                            }).catch((error) => {
                                reject(error);
                            });
                    } else {
                        resolve('unknown');
                    }
                }, (error) => {
                    reject(error);
                });
            } else {
                reject(usernameTelegram + ' tidak ada');
            }
        });
    }

    const lihatAirdrop = (username) => {
        const db = getDatabase();
        const airdrop = query(ref(db, 'listAirdrop/' + username), orderByChild('added'));
        return new Promise((resolve, reject) => {
            onValue(airdrop, (snapshot) => {
                const data = [];
                snapshot.forEach((airdropSnapshot) => {
                    const hasil = airdropSnapshot.val();
                    const penggarap = hasil.penggarap;
                    let count = 0;
                    for (const key in penggarap) {
                        if (Object.hasOwnProperty.call(penggarap, key)) {
                            count += Object.keys(penggarap[key]).length;
                        }
                    }
                    data.push({
                        id: data.length + 1,
                        name: hasil.nameProject,
                        chain: hasil.chain,
                        added: hasil.added,
                        status: count,
                    });
                });
                // Return formatted data
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }

    const cekExists = (username, key, child, value) => {
        const db = getDatabase();
        const user = ref(db, 'users/' + username);
        const cek = query(ref(db, key + '/' + username), orderByChild(child), equalTo(value));
        return new Promise((resolve, reject) => {
            onValue(user, (snapshot) => {
                if (snapshot.exists()) {
                    //lanjut
                    onValue(cek, (cekSnapshot) => {
                        if (cekSnapshot.exists()) {
                            resolve(true)
                        } else {
                            resolve(false);
                        }
                    }, (error) => {
                        reject(error.message);
                    });
                } else {
                    reject("unauthorized")
                }
            }, (error) => {
                reject(error.message);
            });
        })
    }

    const lihatGarapan = (username, project) => {
        const db = getDatabase();
        const airdrop = query(ref(db, 'listAirdrop/' + username), orderByChild('nameProject'), equalTo(project));
        return new Promise((resolve, reject) => {
            onValue(airdrop, (snapshot) => {
                const data = [];
                snapshot.forEach((airdropSnapshot) => {
                    const hasil = airdropSnapshot.val();
                    const penggarapKeys = hasil.penggarap ? Object.keys(hasil.penggarap) : [];
                    const penggarapList = penggarapKeys.map((key) => {
                        return {
                            [key]: hasil.penggarap[key].done
                        };
                    });
                    data.push({
                        id: data.length + 1,
                        name: hasil.nameProject,
                        chain: hasil.chain,
                        link: hasil.link,
                        note: hasil.note,
                        penggarap: penggarapList,
                        totalPenggarap: penggarapList.length,
                        added: hasil.added,
                    });
                });

                // Return formatted data
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }

    const lihatPasukan = (username) => {
        const db = getDatabase();
        const pasukan = query(ref(db, 'pasukan/' + username), orderByChild('added'));
        return new Promise((resolve, reject) => {
            onValue(pasukan, (snapshot) => {
                const data = [];
                snapshot.forEach((pasukanSnapshot) => {
                    const hasil = pasukanSnapshot.val();
                    data.push({
                        id: data.length + 1,
                        telegram: hasil.usernameTelegram,
                        twitter: hasil.twitter
                    });
                });
                // Return formatted data
                resolve(data);
            }, (error) => {
                reject(error.message);
            });
        });
    };

    const lihatWallet = (username) => {
        const db = getDatabase();
        const pasukan = query(ref(db, 'listWallet/' + username), orderByChild('added'));
        return new Promise((resolve, reject) => {
            onValue(pasukan, (snapshot) => {
                const data = [];
                snapshot.forEach((pasukanSnapshot) => {
                    const hasil = pasukanSnapshot.val();
                    data.push({
                        id: data.length + 1,
                        address: hasil.walletAddress,
                        chain: hasil.chain,
                        label: hasil.label,
                        added: hasil.added
                    });
                });
                // Return formatted data
                resolve(data);
            }, (error) => {
                reject(error.message);
            });
        });
    };

    const deleteWallet = (username, p) => {
        const db = getDatabase();
        const q = query(ref(db, 'listWallet/' + username), orderByChild('added'), equalTo(p));
        return new Promise(async (resolve, reject) => {
            onValue(q, (snapshot) => {
                if (snapshot.exists()) {
                    const hasil = snapshot.val();
                    if (hasil) { // added null/undefined check
                        const walletIds = Object.keys(hasil);
                        const test = 'listWallet/' + username + '/' + walletIds;
                        const target = ref(db, test);
                        resolve(true);
                        remove(target)
                    } else {
                        reject('unauthorized')
                    }
                } else {
                    reject('unknown')
                }
            }, (error) => {
                reject(error.message);
            });
        });
    };

    const logout = () => {
        return signOut(auth);
    }

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentuser) => {
            setUser(currentuser)
        })
        return () => {
            unsubscribe();
        }
    }, [user]);

    const generateApiKey = () => {
        const length = 12;
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const numChars = Math.floor(Math.random() * (length - 1)) + 1;
        let key = '';

        // Add random alphanumeric characters to the key
        for (let i = 0; i < numChars; i++) {
            key += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        // Add the '=' character to the key
        key += '=';

        // Add more random alphanumeric characters to the key
        for (let i = numChars + 1; i < length; i++) {
            key += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        return key;
    };

    const setUserDB = (username, email, password, agentID) => {
        const db = getDatabase();
        const date = new Date();
        const referralId = `R-${(Date.now() + Math.floor(Math.random() * 1000000)).toString().substr(-7)}`;
        const formattedDate = `${date.getDate().toString().padStart(2, "0")
            }/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear().toString().slice(-2)} ${date.getHours().toString().padStart(
                2,
                "0"
            )}:${date.getMinutes().toString().padStart(2, "0")}`;
        const setUser = set(ref(db, 'users/' + username), {
            username: username,
            email: email,
            password: password,
            tier: 'free',
            expiry: '',
            registered: formattedDate,
            agentID: referralId,
            invitedBy: agentID
        });
        const pathLimitExtension = 'limit/fitur/extension/' + username;
        const setLimitExtension = set(ref(db, pathLimitExtension), {
            limitAccess: 1,
        });
        const pathApiKey = 'api_key/' + username;
        const setApiKey = set(ref(db, pathApiKey), {
            ApiKey: generateApiKey(),
        });
        return Promise.all([setUser, setLimitExtension, setApiKey]);
    };

    return (
        <UserContext.Provider value={{
            createUser, setUserDB, user,
            logout, signIn, lihatPasukan,
            detailPasukan, deletePasukan, updatePasukan,
            addPasukan, addAirdrop, lihatAirdrop,
            garapAirdrop, lihatGarapan, cekExists,
            addWallet, lihatWallet, deleteWallet,
            savePayment

        }}>
            {children}
        </UserContext.Provider>
    );
}

export const UserAuth = () => {
    return useContext(UserContext)
}